import { styled } from '@nextui-org/react';

export const AppTitle = styled('div', {
  '&::selection': {
    WebkitTextFillColor: '$colors$text',
  },
  alignItems: 'center',
  color: '$text',
  display: 'flex',
  fontWeight: '$bold',
  fs: '$xl',
  gap: '$3',
  letterSpacing: '$tighter',
  lh: '1.2',
  mb: 0,
  variants: {
    color: {
      blue: {
        textGradient: '180deg, $blue300 25%, $blue500 100%',
      },
      cyan: {
        textGradient: '180deg, #00b7fa 25%, #01cfea 100%',
      },
      gray: {
        // textGradient: '180deg, $gray100 25%, $gray900 100%',
      },
      green: {
        textGradient: '180deg, #6FEE8D 25%, #17c964 100%',
      },
      pink: {
        textGradient: '180deg, #FF4ECD 25%, #F21361 100%',
      },
      violet: {
        textGradient: '180deg, #FF1CF7 25%, #b249f8 100%',
      },
      warning: {
        textGradient: '180deg, #f36534 25%, #F69F27 100%',
      },
    },
    fullWidth: {
      true: {
        display: 'block',
        width: '100%',
      },
    },
  },
});
